import React from 'react';
import { File } from '@models/files';
import { Link } from 'react-router-dom';
import { app as routes } from '@configs/routes.json';
import { trimLeadingSlashes } from '@utils/urlUtils';

interface IFolderInfo {
  currentFile: File;
  relativePath: string;
}

export const Folder: React.FC<IFolderInfo> = ({
  currentFile,
  relativePath,
}) => {
  const getUrl = () => {
    let trimmedPath = trimLeadingSlashes(`${relativePath}/${currentFile.name}`);
    let url = routes.filesHierarchy.replace(':relativePath+', trimmedPath);
    return url;
  };

  return (
    <div className='folder-name'>
      <Link to={getUrl()}>
        <i className='fas fa-folder'></i>
        {currentFile.name}
      </Link>
    </div>
  );
};
